import { LOCALES } from '../locales';
export default {
  [LOCALES.ro]: {
    'store/button.close': 'Închide',
    'store/button.expecting': 'Așteptare...',
    'store/button.send': 'Trimite',
    'store/inputs.required-placeholder': 'Obligatoriu',
    'store/live.chat': 'Chat live',
    'store/live.chat-login': 'Scrie-ți numele pentru a continua',
    'store/live.chat-login-btn': 'Continuǎ discuția',
    'store/live.chat-login-email-no-required-placeholder': 'Email',
    'store/live.chat-login-email-required-placeholder': 'Email*',
    'store/live.chat-login-invalid-email': 'Email invalid',
    'store/live.chat-login-invalid-username': 'Nume de utilizator invalid',
    'store/live.chat-login-name-placeholder': 'Nume*',
    'store/live.chat-login-username-already-exist':
      'Acest nume de utilizator există deja',
    'store/live.chat-votes': 'voturi',
    'store/seconds': 'Secunde',
    'store/text.add': 'Adaugă',
    'store/text.anonymous-user': 'Anonim',
    'store/text.before': 'Înainte',
    'store/text.chat-placeholder': 'Scrie un comentariu',
    'store/text.email': 'Email',
    'store/text.email-invalid': 'Email invalid',
    'store/text.false': 'Fals',
    'store/text.likes': 'Aprecieri',
    'store/text.live-no-video': 'Transmisie live',
    'store/text.live-products': 'Produse',
    'store/text.name': 'Nume',
    'store/text.no-video': 'Se așteaptă conexiunea la transmisie',
    'store/text.not-stock': 'Stoc epuizat',
    'store/text.now': 'Acum',
    'store/text.products': 'Produse evidențiate',
    'store/text.recording-text': 'Evenimente anterioare',
    'store/text.select-answer': 'Trebuie să selectezi un răspuns',
    'store/text.true': 'Adevărat',
    'store/text.unread-messages': 'Mesaje necitite',
    'store/time': 'Timp',
    'store/total-votes': 'Total voturi',
    'store/text.add-to-cart': 'Produs adăugat în coș',
    'store/text.add-to-cart-error': 'Eroare la adăugarea în coș',
    'store/text.share': 'Distribuie',
    'store/text.details': 'Vezi detalii',
    'chat.message-max-length': 'Limita de caractere pentru mesaje este 180',
    'chat.show-chat-horizontal-layout-message': 'Afișează reluarea chatului',
    'chat.hide-chat-horizontal-layout-message': 'Ascunde reluarea chatului',
    'chat.mobile-record-playback-indicator-message': 'Înregistrare',
    'chat.chat-replay-mobile-vertical-layout-message': 'Reluare chat',
    'chat-carousel.product-unavailable-message': 'Indisponibil',
    'customize/general.back': 'Înapoi',
    'customize/general.background': 'Fundal',
    'customize/general.price': 'Preț',
    'customize/general.text': 'Text',
    'customize/general.message': 'Mesaj',
    'customize/general.section-title': 'Titlul secțiunii',
    'customize/general.section-name': 'Numele secțiunii',
    'customize/general.icon': 'Pictogramă',
    'customize/general.desktop': 'Desktop',
    'customize/general.mobile': 'Mobil',
    'customize/product-button.add-to-cart-button': 'Buton Adaugă în coș',
    'customize/product-button.text-inside-button': 'Text buton',
    'customize/chat-carousel-product-item.product-carousel': 'Produse pe mobil',
    'customize/highlight-product.product-highlight': 'Produs evidențiat',
    'customize/highlight-product.show': 'Afișează',
    'customize/highlight-product.show-button': 'Afișează butonul',
    'customize/highlight-product.show-price': 'Afișează prețul',
    'customize/highlight-product.opacity': 'Opacitate',
    'customize/product-item.product-cards': 'Produse pe desktop',
    'customize/product-item.highlight-promotion': 'Evidențiază promoția',
    'customize/vertical-product-slider.section-title':
      'Titlul secțiunii de produse',
    'customize/message-container-admin.admin-message': 'Mesaj administrator',
    'customize/message-container-admin.background-layout-horizontal':
      'Fundal pentru aspect pe orizontală',
    'customize/message-container-admin.message-layout-horizontal':
      'Mesaj pentru aspect pe orizontală',
    'customize/message-container-admin.background-layout-vertical':
      'Fundal pentru aspect pe verticală',
    'customize/message-container-admin.message-layout-vertical':
      'Mesaj pentru aspect pe verticală',
    'customize/chat.chat-section-title': 'Titlul secțiunii de chat',
    'customize/chat.comment-box-text': 'Text casetă comentarii',
    'customize/chat.comment-box-title': 'Casetă comentarii',
    'customize/chat.send-message-button.desktop.title':
      'Buton de trimitere pe desktop',
    'customize/modal-trigger.select-product-variations.title':
      'Selectare variante de produs',
    'customize/modal-trigger.round-or-square-selector':
      'Stil de afișare pentru variante',
    'customize/modal-trigger.round-selector': 'Selector rotund',
    'customize/modal-trigger.square-selector': 'Selector pătrat',
  },
};
